import { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  TextField
} from '@mui/material';
import {
  AttachFile as AttachFileIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';

/**
 * Düzenleme modalında dosya/görsel alanı için gelişmiş arayüz
 */
const FileEditField = ({ field, value, onChange }) => {
  const [localFiles, setLocalFiles] = useState(Array.isArray(value) ? value : value ? [value] : []);

  // Dosya ekleme
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const fileReaders = files.map(file => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (ev) => {
          resolve({
            name: file.name,
            type: file.type,
            size: file.size,
            base64: ev.target.result
          });
        };
        reader.readAsDataURL(file);
      });
    });
    Promise.all(fileReaders).then(newFiles => {
      const updatedFiles = [...localFiles, ...newFiles];
      setLocalFiles(updatedFiles);
      onChange(updatedFiles);
    });
  };

  // Dosya silme
  const handleDelete = (idx) => {
    const updatedFiles = localFiles.filter((_, i) => i !== idx);
    setLocalFiles(updatedFiles);
    onChange(updatedFiles);
  };

  // Dosya boyutunu formatla
  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return '';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  // Görsel dosya mı?
  const isImageFile = (fileName = '', mimeType = '') => {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.tiff'];
    const ext = fileName ? fileName.toLowerCase().slice(fileName.lastIndexOf('.')) : '';
    return mimeType.startsWith('image/') || imageExtensions.includes(ext);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {/* Mevcut dosyalar */}
      {localFiles.length > 0 && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {localFiles.map((file, idx) => (
            <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 1, border: '1px solid #e0e0e0', borderRadius: 2, bgcolor: '#f5f5f5' }}>
              {isImageFile(file.name, file.type) && file.base64 ? (
                <Box component="img" src={file.base64} alt={file.name} sx={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 1, border: '1px solid #ccc' }} />
              ) : (
                <AttachFileIcon color="primary" />
              )}
              <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle2">{file.name}</Typography>
                <Typography variant="caption" color="text.secondary">{formatFileSize(file.size)} {file.type}</Typography>
              </Box>
              <Button
                size="small"
                variant="outlined"
                color="primary"
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = file.base64;
                  link.download = file.name || 'download';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                sx={{ mr: 1 }}
              >
                İndir
              </Button>
              <Button
                size="small"
                variant="outlined"
                color="error"
                onClick={() => handleDelete(idx)}
              >
                Sil
              </Button>
            </Box>
          ))}
        </Box>
      )}
      {/* Dosya ekleme alanı */}
      <Button
        variant="contained"
        component="label"
        sx={{ width: 'fit-content' }}
      >
        Dosya Ekle
        <input
          type="file"
          hidden
          multiple={field.allowMultiple || true}
          accept={field.accept || '*/*'}
          onChange={handleFileChange}
        />
      </Button>
    </Box>
  );
};

export default FileEditField;
